import { createSelector } from "reselect";
import { programmingTypes } from "./cycles.enum";

export const cycleSelector = createSelector(
  (state) => state?.customersReducer.customer?.accounts,
  (state) => state?.customersReducer.cyclesTypes,
  (accounts, cyclesTypes) => {
    if (!accounts) return [];
    const allCycles = [];

    accounts.forEach((account) => {
      if (account.cycles && Array.isArray(account.cycles) && account.cycles.length > 0) {
        account.cycles.forEach((cycle) => {
          const label = cyclesTypes?.find(
            (cy) => cy.id === cycle.idCycleType
          );

          allCycles.push({
            id: account.id,
            alias: account.alias,
            idStation: account.idStation,
            cycle: {
              ...cycle,
              cycleLabel: label?.label,
              category: cycle.category || programmingTypes.PEDIDO,
              idAccount: account.id
            },
          });
        });
      }
    });

    return allCycles;
  }
);
